import { ENDPOINT_MCP_OAUTH_CONNECTIONS } from '../config'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const revokeMcpOauthConnection = async (id: string): Promise<void> => {
  await AuthAxios.delete(`${ENDPOINT_MCP_OAUTH_CONNECTIONS}/${id}`)
}

export default revokeMcpOauthConnection
